import React, { useState } from "react";
import useEmblaCarousel from "embla-carousel-react";

type GalleryProps = {
    images: string[];
};

export function Gallery(props: GalleryProps) {
    const { images } = props;
    const [currentImage, setCurrentImage] = useState(0);
    const [emblaRef] = useEmblaCarousel({
        align: "start",
        dragFree: true,
    });

    const hasImages = images && images?.length > 0;
    const multipleImages = images && images?.length > 1;

    return (
        <div>
            {multipleImages && (
                <div
                    data-testid="gallery"
                    className="grid gap-[15px] lg:gap-[30px]"
                >
                    <div className="relative aspect-[777/500] w-full object-cover object-center">
                        <div
                            className="w-full h-full absolute inset-0 right-0 rounded-lg bg-cover bg-center"
                            style={{
                                backgroundImage: images?.[currentImage]
                                    ? `url("${images?.[currentImage]}")`
                                    : `url("/images/placeholder.png")`,
                            }}
                        />
                    </div>

                    <div
                        ref={emblaRef}
                        className="relative flex justify-center overflow-hidden"
                    >
                        <div className="flex items-center gap-[10px]">
                            {images?.map((_image, index) => (
                                <div key={index}>
                                    <button
                                        data-testid={`gallery__dot-${index}`}
                                        className={`h-[10px] w-[10px] rounded-full ${
                                            currentImage === index
                                                ? "bg-brand-secondary"
                                                : "bg-brand-grey"
                                        }`}
                                        onClick={() => setCurrentImage(index)}
                                    ></button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {(!hasImages || (hasImages && !multipleImages)) && (
                <div data-testid="gallery">
                    <div className="relative aspect-[777/500] w-full object-cover object-center">
                        <div
                            className="w-full h-full absolute inset-0 right-0 rounded-lg bg-cover bg-center"
                            style={{
                                backgroundImage: images?.[0]
                                    ? `url("${images?.[0]}")`
                                    : `url("/images/placeholder.png")`,
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
